import {useEffect} from 'react'

import {usesInventorySelector} from '../../data/company.js'
import {
  refreshProductList,
  hasSelectedSKUsSelector,
  productListQuerySelector,
} from './productListFunctions.js'
import ProductListItemsCount from './ProductListItemsCount.js'
import RefreshProducts from './RefreshProducts.js'
import ExpandAll from './ExpandAll.js'
import ProductSort from './ProductSort.js'
import Actions from './Actions.js'
import ActionsForSelected from './ActionsForSelected.js'
import Pro from './Pro/index.js'
import Basic from './Basic/index.js'
import Modals from './Modals/index.js'
import ProductListOmniBar from './ProductListOmniBar.js'
import {hasProductPermissionSelector} from '../../data/me.js'
import NoPermissionsPage from '../NoPermissionsPage.js'
import {useSelector} from '../../store.js'
import {showProductListFilterModal} from './Modals/ProductListFilterModal/productListFilterModalFunctions.js'
import {navigateToStocktakeListPage} from '../StocktakeListPage/stocktakeListFunctions.js'
import {canUseStocktakeSelector} from '../../data/stocktakes.js'
import FiltersButton from '../../common/components/FiltersButton.js'
import {navigateToTransferListPage} from '../TransferListPage/transferListFunctions.js'
import {canUseTransferSelector} from '../../data/transfers.js'

export default function ProductListPage() {
  useEffect(() => {
    document.title = 'Products'
  }, [])

  const query = useSelector(productListQuerySelector)
  const hasSelectedSKUs = useSelector(hasSelectedSKUsSelector)
  const usesInventory = useSelector(usesInventorySelector)
  const hasProductPermission = useSelector(hasProductPermissionSelector)
  const canUseStocktake = useSelector(canUseStocktakeSelector)
  const canUseTransfer = useSelector(canUseTransferSelector)

  useEffect(() => {
    refreshProductList()
  }, [query])

  if (!hasProductPermission) {
    return <NoPermissionsPage />
  }

  return (
    <div id="iverson-page">
      <Modals />
      <div className="wrap--container">
        <div className="wrap--row">
          <div className="medium-12 columns">
            <div className="wrap--list-header wrap--list-header-products padding-top-10 padding-bottom-10 flex--justify">
              <ul className="list list--no-style list--product-top-bar">
                <ProductListItemsCount />
                <RefreshProducts />
                <ExpandAll />
                <li className="inline-block divider--left">
                  <FiltersButton
                    onClick={() => showProductListFilterModal({query})}
                  />
                </li>
                <ProductSort />
                {hasSelectedSKUs ? <ActionsForSelected /> : <Actions />}
                {canUseStocktake && (
                  <li className="inline-block divider--left">
                    <button
                      className="btn btn--action v-align-base"
                      type="button"
                      onClick={() => navigateToStocktakeListPage()}
                    >
                      Stocktakes
                    </button>
                  </li>
                )}
                {canUseTransfer && (
                  <li className="inline-block divider--left">
                    <button
                      className="btn btn--action v-align-base"
                      type="button"
                      onClick={() => navigateToTransferListPage()}
                    >
                      Transfers
                    </button>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
        <div className="wrap--row">
          <div className="medium-12 columns">
            <ProductListOmniBar />
          </div>
        </div>
        {usesInventory ? <Pro /> : <Basic />}
      </div>
    </div>
  )
}
